import { useState, useEffect } from "react";

const useIsMobile = () => {
  const [isInRange, setIsInRange] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsInRange(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isInRange;
};

export default useIsMobile;